import { ion } from '../../factories/ion.js';
import { injectAtomGetters } from '../../injectors/injectAtomGetters.js';
import { AtomInstance } from '../instances/AtomInstance.js';
import { AtomTemplateBase } from './AtomTemplateBase.js';
export class IonTemplate extends AtomTemplateBase {
    constructor(key, stateFactory, _config) {
        super(key, (...params) => stateFactory(injectAtomGetters(), ...params), _config);
        this._get = stateFactory;
    }
    _createInstance(ecosystem, id, params) {
        return new AtomInstance(ecosystem, this, id, params);
    }
    getInstanceId(ecosystem, params) {
        const base = this.key;
        if (!(params === null || params === void 0 ? void 0 : params.length))
            return base;
        return `${base}-${ecosystem._idGenerator.hashParams(params, ecosystem.complexParams)}`;
    }
    override(newGet) {
        const newIon = ion(this.key, newGet || this._get, this._config);
        newIon._isOverride = true;
        return newIon;
    }
}
